import InvoiceRow from "./InvoiceRow";
import styles from "../styles/invoice.module.css";

export default function TableBody({
  invoices,
  onEdit,
  onDelete,
  onEmail,
  selectedIds = new Set(),
  onToggleSelect,
}) {
  return (
    <div className={`${styles["table-body"]} ${styles["table-responsive"]}`}>
      <table>
        <thead>
          <tr>
            <th style={{ width: 36, paddingRight: 0 }}></th>
            <th>Factura</th>
            <th>Filial</th>
            <th>Propietario</th>
            <th>Rubro / Período</th>
            <th>Fecha</th>
            <th className={styles.monto}>Monto</th>
            <th className="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {invoices.map((inv) => (
            <InvoiceRow
              key={inv.id_factura ?? inv.id}
              invoice={inv}
              onEdit={onEdit}
              onDelete={onDelete}
              onEmail={onEmail}
              selected={selectedIds.has(inv.id_factura ?? inv.id)}
              onToggleSelect={onToggleSelect}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
